import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'spaceReplace',
    standalone: false
})
export class ReplaceSpacePipe implements PipeTransform{
  transform(value: string): any {
    return value.replace(/\s/g, "-")
  }
}
